// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"5896f2b5","353":"f4664677","804":"dd6827d2"}[chunkId] + ".js";
};